/*
 * EM Pack PDF — Génère une présentation PDF du pack via window.print()
 * Pas de dépendance externe. Le navigateur convertit en PDF via le dialog d'impression.
 */
(function () {
  const btn = document.querySelector('[data-em-pdf-btn]');
  if (!btn) return;

  function getCardData() {
    const sections = [];
    document.querySelectorAll('[data-view="pack"] .em-pack__cat-section').forEach(section => {
      const catName = section.querySelector('.em-pack__cat-title')?.textContent?.trim() || 'Autre';
      const cards = section.querySelectorAll('[data-em-card]');
      if (!cards.length) return;
      const items = Array.from(cards).map(card => {
        const img = card.querySelector('img');
        return {
          title: card.dataset.productTitle || (card.querySelector('.em-pack-card__title')?.textContent?.trim() || ''),
          qty: parseInt(card.dataset.qty, 10) || 1,
          unitPriceCents: parseInt(card.dataset.unitPrice, 10) || 0,
          image: img ? img.src : '',
        };
      });
      sections.push({ name: catName, items });
    });
    return sections;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
      ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c])
    );
  }
  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', { style:'currency', currency:'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
  }

  function buildHtml() {
    const meta = window.EM_PACK_META || {};
    const packName = meta.name || document.querySelector('.em-pack__intro-title')?.textContent?.trim() || 'Pack Easy Mobilier';
    const totalText = document.querySelector('[data-total-price]')?.textContent?.trim() || '';
    const articles = document.querySelector('[data-total-count]')?.textContent?.trim() || '';
    const products = document.querySelector('[data-total-products]')?.textContent?.trim() || '';
    const today = new Intl.DateTimeFormat('fr-FR', { day:'numeric', month:'long', year:'numeric' }).format(new Date());
    const pageUrl = window.location.origin + window.location.pathname + window.location.hash;
    const sections = getCardData();

    let grandTotalCents = 0;
    sections.forEach(s => s.items.forEach(it => grandTotalCents += it.unitPriceCents * it.qty));

    const sectionsHtml = sections.map(s => {
      const catTotalCents = s.items.reduce((sum, it) => sum + it.unitPriceCents * it.qty, 0);
      const catArticles = s.items.reduce((sum, it) => sum + it.qty, 0);
      const rows = s.items.map(it => `
        <tr>
          <td class="img">${it.image ? `<img src="${escapeHtml(it.image)}" alt="">` : ''}</td>
          <td class="name">${escapeHtml(it.title)}</td>
          <td class="qty">${it.qty}</td>
          <td class="unit">${formatMoney(it.unitPriceCents)}</td>
          <td class="total">${formatMoney(it.unitPriceCents * it.qty)}</td>
        </tr>
      `).join('');
      return `
        <section class="cat">
          <div class="cat-head">
            <h2>${escapeHtml(s.name)}</h2>
            <div class="cat-meta">${s.items.length} produit${s.items.length>1?'s':''} · ${catArticles} article${catArticles>1?'s':''} · <strong>${formatMoney(catTotalCents)}</strong></div>
          </div>
          <table>
            <thead><tr><th></th><th>Produit</th><th>Qté</th><th>P.U.</th><th>Total</th></tr></thead>
            <tbody>${rows}</tbody>
          </table>
        </section>
      `;
    }).join('');

    return `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="utf-8">
<title>${escapeHtml(packName)} — Easy Mobilier</title>
<style>
@import url('https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700,900&display=swap');
* { box-sizing: border-box; }
body {
  margin: 0;
  font-family: 'Satoshi', system-ui, sans-serif;
  color: #1E3D33;
  font-size: 11px;
  line-height: 1.45;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.page { padding: 18mm 14mm; }
header.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 2px solid #29594b;
  padding-bottom: 14px;
  margin-bottom: 22px;
}
.brand { font-weight: 900; font-size: 22px; color: #1E3D33; letter-spacing: -0.01em; }
.brand-tag { font-size: 11px; color: #5A6A64; margin-top: 2px; }
.meta-block { text-align: right; font-size: 11px; color: #5A6A64; }
.meta-date { color: #1E3D33; font-weight: 600; }

h1.pack-title {
  font-size: 32px;
  font-weight: 900;
  margin: 0 0 8px;
  color: #1E3D33;
  letter-spacing: -0.02em;
  line-height: 1.1;
}
.totals {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.totals .price {
  font-size: 28px;
  font-weight: 800;
  color: #29594b;
  letter-spacing: -0.01em;
}
.totals .count { font-size: 13px; color: #5A6A64; }

.cat { margin-bottom: 16px; page-break-inside: avoid; }
.cat-head {
  background: #E8F0EA;
  border-radius: 8px;
  padding: 8px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.cat h2 { font-size: 14px; font-weight: 700; margin: 0; color: #1E3D33; }
.cat-meta { font-size: 11px; color: #5A6A64; }
.cat-meta strong { color: #1E3D33; font-weight: 700; }

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}
thead th {
  text-align: left;
  font-weight: 700;
  font-size: 9.5px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7A8A84;
  padding: 6px 8px;
  border-bottom: 1px solid #E3E9E5;
}
thead th.qty, thead th.unit, thead th.total { text-align: right; }
tbody td {
  padding: 8px;
  border-bottom: 1px solid #F1F3F1;
  vertical-align: middle;
}
td.img { width: 36px; }
td.img img { width: 32px; height: 32px; object-fit: contain; display: block; }
td.name { font-weight: 600; color: #1E3D33; }
td.qty { width: 40px; text-align: right; color: #5A6A64; }
td.unit { width: 70px; text-align: right; color: #5A6A64; }
td.total { width: 80px; text-align: right; font-weight: 700; color: #1E3D33; }

footer.foot {
  margin-top: 28px;
  border-top: 1px solid #E3E9E5;
  padding-top: 14px;
  font-size: 10px;
  color: #5A6A64;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.foot-contact strong { color: #1E3D33; }
.foot-url { font-size: 9.5px; word-break: break-all; max-width: 60%; }

@media print {
  body { font-size: 10px; }
  .cat { page-break-inside: avoid; }
}
</style>
</head>
<body>
<div class="page">
  <header class="head">
    <div>
      <div class="brand">Easy Mobilier</div>
      <div class="brand-tag">Location & vente de packs mobilier — Livraison 7 jours, installation incluse.</div>
    </div>
    <div class="meta-block">
      <div class="meta-date">${escapeHtml(today)}</div>
      <div>Devis indicatif</div>
    </div>
  </header>

  <h1 class="pack-title">${escapeHtml(packName)}</h1>
  <div class="totals">
    <span class="price">${escapeHtml(totalText || formatMoney(grandTotalCents))}</span>
    <span class="count">${escapeHtml(products)} produits · ${escapeHtml(articles)} articles</span>
  </div>

  ${sectionsHtml}

  <footer class="foot">
    <div class="foot-contact"><strong>Easy Mobilier</strong> · 04 74 94 65 88 · Lun–Ven 9h–18h · easy-mobilier.com</div>
    <div class="foot-url">${escapeHtml(pageUrl)}</div>
  </footer>
</div>
<script>
  // Auto-print après chargement des images
  window.addEventListener('load', () => {
    setTimeout(() => { window.focus(); window.print(); }, 350);
  });
</script>
</body>
</html>`;
  }

  btn.addEventListener('click', () => {
    const html = buildHtml();
    const win = window.open('', '_blank');
    if (!win) {
      alert("Pop-up bloquée — autorise les pop-ups pour télécharger le PDF.");
      return;
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
  });
})();
